import { Route, Routes } from "react-router-dom";
import { Home } from "./pages/Home";
import { TransectionList } from "./pages/TransectionList";

const App = () => {
    return (
        <section className="py-10">
            <div className="container px-3 md:px-0 mx-auto">
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/transactions" element={<TransectionList />} />
                </Routes>
            </div>
        </section>
    );
};

export default App;
